export default [
  {
    header: 'CRM Admin',
  },
  {
    title: 'Gestione accessi',
    icon: 'UsersIcon',
    children: [
      {
        title: 'Aziende',
        route: 'crm-aziende',
      },
      {
        title: 'Nuova azienda',
        route: 'crm-aziende-nuovo',
      },
    ],
  },
  {
    title: 'Catalogo',
    icon: 'ShoppingCartIcon',
    children: [
      {
        title: 'Articoli',
        route: 'crm-catalogo-lista',
      },
      {
        title: 'Nuovo articolo',
        route: 'crm-catalogo-nuovo',
      },
    ],
  },
  {
    title: 'Richieste Aziende',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'In attesa',
        route: 'crm-leads-in-attesa',
      },
      {
        title: 'In corso',
        route: 'crm-leads-in-corso',
      },
      {
        title: 'Concluse',
        route: 'crm-leads-conlcuse',
      },
      {
        title: 'Nel cestino',
        route: 'crm-leads-nel-cestino',
      },
    ],
  },
  {
    title: 'Ordini Aziende',
    route: 'crm-ordini',
    icon: 'BoxIcon'
  },
  
]
